import { render, staticRenderFns } from "./WtiDashboard.vue?vue&type=template&id=9f0fd3be&scoped=true&"
import script from "./WtiDashboard.vue?vue&type=script&lang=js&"
export * from "./WtiDashboard.vue?vue&type=script&lang=js&"
import style0 from "./WtiDashboard.vue?vue&type=style&index=0&id=9f0fd3be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0fd3be",
  null
  
)

export default component.exports